import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { NameTextInput as _NameTextInput } from 'routes/surface/components/node-modal-form/style';

export const ProtocolNodeRepresentation = styled.div`
  height: 360px;
  width: 360px;
  background-color: #fff;
  border: 2px dashed rgb(187, 186, 186);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  top: calc(20% - 180px);
  left: calc(50% - 180px);
  position: relative;
  background-color: ${color.neutral.grayLighter};
`;

export const NameTextInput = styled(_NameTextInput)`
  width: 100%;
  display: block;
  max-width: 100%;
  ${typography.font.title.bold};
  font-size: ${typography.size.xxxl};
  color: ${color.neutral.plainBlack};
  height: 81px;
  line-height: 81px;
  text-align: center;
  padding: 0;
`;

export const Container = styled.div`
  width: 100%;
  display: block;
  max-width: 100%;
  font-size: ${typography.size.md};
  color: ${color.neutral.plainBlack};
  /* height: 41px;
  line-height: 41px; */
  text-align: center;
  padding: 0;
`;

export const TextInput = styled(_NameTextInput)`
  width: 100%;
  display: block;
  max-width: 100%;
  font-size: ${typography.size.md};
  color: ${color.neutral.plainBlack};
  /* height: 41px;
  line-height: 41px; */
  text-align: center;
  padding: 0;
`;

export const ProtocolNodeWrapper = styled.div`
  margin: 46px auto 40px auto;
`;
